import {
	buildShareMessage,
	buildWhatsAppShareUrl,
	getShareArtifactLabel,
} from "@shared/types";

// Re-exported under the existing frontend names for stable callers and tests.
// The canonical helpers live in `packages/shared-types` so backend services,
// agent integrations, and the frontend share a single message/URL contract
// (todo 022 — agent-native parity).
export const getArtifactLabel = getShareArtifactLabel;
export { buildShareMessage };
export const buildWhatsAppUrl = buildWhatsAppShareUrl;
